import React, { useState } from "react";

const DropdownItem = ({
  title,
  onClick,
  items,
  icon,
  isDisabled,
  disabled,
}) => {
  const [openSubMenu, setOpenSubMenu] = useState();
  const toggleSubMenu = () => {
    if (isDisabled || disabled) {
      return;
    }
    setOpenSubMenu((prev) => !prev);
  };
  const handleClick = (value) => {
    if (isDisabled || disabled) {
      return;
    }
    return onClick(value);
  };
  return (
    <div
      className={`p-2 ${isDisabled ? "" : "hover:bg-vb-highlight"} rounded-xl ${
        openSubMenu ? "bg-vb-highlight" : ""
      } ${isDisabled ? "opacity-50" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        items?.length ? toggleSubMenu() : handleClick();
      }}
    >
      <div
        className={
          "space-x-3.5 flex w-full items-center gap-y-5 " +
          (isDisabled ? "" : "cursor-pointer")
        }
      >
        <img src={icon} alt={title} />
        <label className={`text-sm ${isDisabled ? "" : "cursor-pointer"}`}>
          {title}
        </label>
        {!!items?.length && (
          <img
            className="!ml-auto"
            src="/tool/dashboard/static/images/icons/tools/arrow-right.svg"
          />
        )}
      </div>
      {openSubMenu && (
        <div className="grid grid-cols-3 gap-5 my-2 justify-center">
          {(items || []).map((item) => {
            return (
              <img
                className="m-auto cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleSubMenu();
                  return handleClick(item.value);
                }}
                key={item.title}
                src={item.icon}
                alt={item.title}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

const Dropdown = ({ menu = [], className }) => {
  return (
    <div
      className={
        "absolute w-full-h-full bg-white rounded-md z-50 " +
        (className || "")
      }
    >
      {menu
        .filter((m) => !m.isHidden)
        .map((rest) => {
          return <DropdownItem key={rest.title} {...rest} />;
        })}
    </div>
  );
};

export default Dropdown;
